import { Box } from '@mui/material';
import { css, styled } from '@mui/material/styles';
import { NationalNumber } from 'libphonenumber-js';

import { TicketSubTypeOption } from 'utils/TicketType.utils';

import { Language } from 'models/Patient';
import PatientLocation from 'models/PatientLocation';
import PatientProvider from 'models/PatientProvider';

import { ISelectOption } from 'views/Widgets/StyledSelect';

import { LightweightPathwayQuestionAnswer } from 'components/LightweightPathway/LightweightPathway.types';

// contact consts
export const PATIENT_IS_CONTACT_VALUE = '-1';
export const NEW_CONTACT_VALUE = '0';

export interface LightweightPathwaySummary {
  activeQuestionsCount: number;
  pathwayId: string;
  pathwayName: string;
  unansweredQuestions: string[];
}
export interface TicketFormField {
  urgency: { label: string; value: number };
  notes: string;
  providerId: ISelectOption<PatientProvider> | null;
  locationId: ISelectOption<PatientLocation> | null;
  assignee: ISelectOption<number> | null;
  categoryId: string;
  ticketSubTypeIds: string[];
  parentId: number | null;
  ticketTypeSelectorValue: TicketSubTypeOption | TicketSubTypeOption[] | null;
  lightweightPathwaySummaries: LightweightPathwaySummary[] | null;
  lightweightPathwaysAnswers: LightweightPathwayQuestionAnswer[];
  suggestedUrgency: number;
}

export interface TicketFormType {
  value: string;
  label: string;
  parentId?: number;
}

interface OperatorTicketFormFields {
  phone: NationalNumber;
  phoneExtension: string;
  callbackName: string;
  contactId: string;
  callbackRelationship: { value: string; label: string };
  callbackHippaAuth: boolean;
  countryCode: string;
  language: { value: Language; label: string };
}

export interface IOperatorCreateTicketsFormFields extends OperatorTicketFormFields {
  ticketTypes: TicketFormType[];
  tickets: TicketFormField[];
  messagingConsent?: string;
}

export interface IOperatorUpdateTicketFormFields extends OperatorTicketFormFields {
  ticket: TicketFormField;
  messagingConsent?: string;
}

export const StyledCreateTicketCardContainer = styled(Box)(
  ({ theme }) =>
    css`
      display: flex;
      border: 1px solid ${theme.palette.natural.border};
      border-radius: ${theme.borderRadius.medium};
      transition: border-color 0.2s ease-in-out;
      background-color: ${theme.palette.natural.white};
      color: ${theme.palette.secondary.dark};
    `
);
